// @flow
// $FlowFixMe - Cannot import useEffect because there is no useEffect export in react.
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';
import NotificationMessage from '../NotificationMessage';
import TextInput from './TextInput';

export const TextInputHookFormLayout = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 4px;
`;

type TextInputHookFormProps = {
  'aria-label': string,
  defaultValue?: ?string | boolean | number,
  disabled?: boolean,
  name: string,
  rules?: ?any,
};

const TextInputHookForm = ({
  defaultValue,
  disabled,
  name,
  rules,
  ...props
}: TextInputHookFormProps) => {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);
    }
  }, [setValue, defaultValue, name]);

  const errorText = errors?.[name]?.message;

  return (
    <TextInputHookFormLayout>
      <TextInput
        {...register(name, rules)}
        defaultValue={defaultValue}
        disabled={disabled}
        errorText={errorText}
        name={name}
        {...props}
      />
      {errorText && <NotificationMessage styleType="error">{errorText}</NotificationMessage>}
    </TextInputHookFormLayout>
  );
};

TextInputHookForm.defaultProps = {
  defaultValue: undefined,
  disabled: false,
  rules: undefined,
};

export default TextInputHookForm;
